"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.delete.confirm.title': 'Eliminar Rama',
    'branch.delete.confirm.message': '¿Está seguro de que desea eliminar esta rama?',
};
